<template>
  <!-- 基本信息 -->
  <div class="w-full h-full pb-5">
    <el-row
      class="w-full overflow-y-auto overflow-x-hidden p-5"
      :class="[pageType === 'detail' ? 'nobutton-height' : 'withbutton-height']"
    >
      <el-col :span="24">
        <div>
          <el-form ref="formBase" label-width="150px" :rules="rules" :model="formData">
            <el-collapse v-model="activeNames">
              <el-collapse-item name="baseInfo" class="relative">
                <template slot="title">
                  <span>人员信息</span>
                </template>
                <div
                  class="absolute left-79px top-92px text-red-500 z-999 cursor-pointer"
                  @click.stop="damendExample"
                >
                  (查看上传要求)
                </div>
                <el-row :gutter="10">
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
                    <el-form-item label="人脸头像" prop="headshotFileId" ref="headshotFileId">
                      <img-upload
                        v-model="formData.headshotFileId"
                        :authLevel="2"
                        @delete="deleteImg(index, 'headshotFileId')"
                        :isDisabledUploadComponent="pageType === 'detail' || pageType === 'audit'"
                        :isShowDeleteButton="pageType !== 'detail' && pageType !== 'audit'"
                        @change="fileIdChange('headshotFileId')"
                        :maxSize="0.2"
                        :accept="['jpg']"
                      ></img-upload>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
                    <el-form-item
                      label="身份证正面"
                      prop="idCardFrontFileId"
                      ref="idCardFrontFileId"
                    >
                      <img-upload
                        v-model="formData.idCardFrontFileId"
                        :isDisabledUploadComponent="pageType === 'detail' || pageType === 'audit'"
                        :isShowDeleteButton="pageType !== 'detail' && pageType !== 'audit'"
                        @delete="deleteImg(index, 'idCardFrontFileId')"
                        @upload-success="getImageContent"
                        @change="fileIdChange('idCardFrontFileId')"
                      ></img-upload>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
                    <el-form-item
                      label="身份证反面"
                      prop="idCardReverseFileId"
                      ref="idCardReverseFileId"
                    >
                      <img-upload
                        v-model="formData.idCardReverseFileId"
                        :isDisabledUploadComponent="pageType === 'detail' || pageType === 'audit'"
                        :isShowDeleteButton="pageType !== 'detail' && pageType !== 'audit'"
                        @delete="deleteImg(index, 'idCardReverseFileId')"
                        @change="fileIdChange('idCardReverseFileId')"
                      ></img-upload>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    <el-form-item label="所属单位" prop="contractorId">
                      <el-select
                        size="small"
                        class="w-full"
                        filterable
                        placeholder="请选择所属单位"
                        v-model="formData.contractorId"
                        :disabled="
                          pageType === 'detail' || accountType === 0 || pageType === 'audit'
                        "
                        @change="changeContractorId"
                      >
                        <el-option
                          v-for="item in contractorNames"
                          :key="item.id"
                          :label="item.orgName"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    <el-form-item label="人员分类" prop="personnelCategory">
                      <el-select
                        size="small"
                        class="w-full"
                        placeholder="请选择人员分类"
                        v-model="formData.personnelCategory"
                        filterable
                        :disabled="pageType === 'detail' || pageType === 'audit'"
                      >
                        <el-option
                          v-for="item in personnelCategoryList"
                          :key="item.code"
                          :label="item.displayName"
                          :value="Number(item.code)"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    <el-form-item label="姓名" prop="name">
                      <el-input
                        size="small"
                        v-model="formData.name"
                        maxlength="50"
                        show-word-limit
                        placeholder="请输入姓名"
                        :disabled="
                          pageType === 'detail' || accountType === 0 || pageType === 'audit'
                        "
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    <el-form-item label="联系电话" prop="phoneNumber">
                      <el-input
                        size="small"
                        v-model="formData.phoneNumber"
                        placeholder="请输入联系电话"
                        :disabled="
                          pageType === 'detail' || accountType === 0 || pageType === 'audit'
                        "
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    <el-form-item label="身份证号码" prop="idCard">
                      <el-input
                        size="small"
                        v-model="formData.idCard"
                        :disabled="
                          pageType === 'detail' || accountType === 0 || pageType === 'audit'
                        "
                        placeholder="请输入身份证号码"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    <el-form-item label="年龄" prop="age">
                      <el-input
                        size="small"
                        v-model.number="formData.age"
                        :disabled="pageType === 'detail' || pageType === 'audit'"
                        placeholder="请输入年龄"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    <el-form-item label="性别" prop="sex">
                      <el-select
                        size="small"
                        class="w-full"
                        placeholder="请选择性别"
                        v-model="formData.sex"
                        :disabled="
                          pageType === 'detail' || pageType === 'audit' || accountType === 0
                        "
                      >
                        <el-option
                          v-for="item in sexList"
                          :key="item.code"
                          :label="item.displayName"
                          :value="Number(item.code)"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    <el-form-item label="民族" prop="national">
                      <el-input
                        size="small"
                        v-model="formData.national"
                        maxlength="50"
                        show-word-limit
                        :disabled="pageType === 'detail' || pageType === 'audit'"
                        placeholder="请输入民族"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    <el-form-item label="文化程度" prop="education">
                      <el-select
                        size="small"
                        class="w-full"
                        filterable
                        placeholder="请选择文化程度"
                        :disabled="pageType === 'detail' || pageType === 'audit'"
                        v-model="formData.education"
                      >
                        <el-option
                          v-for="item in educationList"
                          :key="item.code"
                          :label="item.displayName"
                          :value="Number(item.code)"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    <el-form-item label="是否临用工" prop="isTemp">
                      <el-radio-group
                        :disabled="pageType === 'detail' || pageType === 'audit'"
                        size="small"
                        v-model="formData.isTemp"
                      >
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    <el-form-item label="职务/工种" prop="dutieJob">
                      <!-- <el-select
                        size="small"
                        class="w-full"
                        filterable
                        :disabled="pageType === 'detail' || pageType === 'audit'"
                        placeholder="请选择职务/工种"
                        v-model="formData.dutieJob"
                      >
                        <el-option
                          v-for="item in dutieJobList"
                          :key="item.code"
                          :label="item.displayName"
                          :value="Number(item.code)"
                        ></el-option>
                      </el-select> -->
                      <el-input
                        size="small"
                        v-model="formData.dutieJob"
                        placeholder="请输入职务/工种"
                        :disabled="pageType === 'detail' || pageType === 'audit'"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    <el-form-item label="分包单位" prop="projectName">
                      <el-input
                        size="small"
                        v-model="formData.projectName"
                        placeholder="请输入分包单位"
                        :disabled="pageType === 'detail' || pageType === 'audit'"
                      ></el-input>
                      <!-- <el-select
                        size="small"
                        class="w-full"
                        filterable
                        placeholder="请选择关联项目"
                        v-model="formData.projectId"
                        :disabled="pageType === 'detail' || pageType === 'audit'"
                      >
                        <el-option
                          v-for="item in projectList"
                          :key="item.id"
                          :label="item.projectName"
                          :value="item.id"
                        ></el-option>
                      </el-select> -->
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    <el-form-item label="所属专业" prop="projectId">
                      <el-select
                        size="small"
                        class="w-full"
                        filterable
                        placeholder="请选择所属专业"
                        v-model="formData.ownerdSpecialtyId"
                        disabled
                      >
                        <el-option
                          v-for="item in specialtyList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    <el-form-item label="参加工作时间" prop="joinedWorkTime">
                      <el-date-picker
                        size="small"
                        class="!w-full"
                        v-model="formData.joinedWorkTime"
                        type="date"
                        placeholder="请选择时间"
                        clearable
                        :disabled="pageType === 'detail' || pageType === 'audit'"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    <el-form-item label="保险种类" prop="insuranceType">
                      <el-input
                        size="small"
                        v-model="formData.insuranceType"
                        placeholder="请输入保险种类"
                        :disabled="pageType === 'detail' || pageType === 'audit'"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    <el-form-item label="保险有效期" prop="insuranceValidityPeriod">
                      <el-date-picker
                        size="small"
                        class="!w-full"
                        v-model="formData.insuranceValidityPeriod"
                        type="date"
                        placeholder="请选择时间"
                        clearable
                        :disabled="pageType === 'detail' || pageType === 'audit'"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    <!-- 非必填字段 -->
                    <el-form-item label="赔偿限额/每人" prop="compensationLimit">
                      <el-input
                        size="small"
                        v-model="formData.compensationLimit"
                        type="number"
                        placeholder="请输入赔偿限额"
                        :disabled="pageType === 'detail' || pageType === 'audit'"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    <el-form-item label="体检是否合格" prop="isPhysicalExaminationQualified">
                      <el-radio-group
                        :disabled="pageType === 'detail' || pageType === 'audit'"
                        size="small"
                        v-model="formData.isPhysicalExaminationQualified"
                      >
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    <el-form-item label="劳动合同终止日期" prop="laborContractTerminationDate">
                      <el-date-picker
                        size="small"
                        class="!w-full"
                        v-model="formData.laborContractTerminationDate"
                        type="date"
                        placeholder="请选择时间"
                        clearable
                        :disabled="pageType === 'detail' || pageType === 'audit'"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    <el-form-item label="家庭住址" prop="homeAddress">
                      <el-input
                        size="small"
                        v-model="formData.homeAddress"
                        placeholder="请输入家庭住址"
                        :disabled="pageType === 'detail' || pageType === 'audit'"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    <el-form-item label="班组" prop="teamId">
                      <el-select
                        size="small"
                        class="w-full"
                        filterable
                        placeholder="请选择班组"
                        v-model="formData.teamId"
                        :disabled="pageType === 'detail' || pageType === 'audit'"
                      >
                        <el-option
                          v-for="item in teamList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" v-if="showCountInfo">
                    <el-form-item label="人员定位标签" prop="peopleTargetingLabels">
                      <el-input
                        size="small"
                        v-model="formData.peopleTargetingLabels"
                        placeholder="请输入人员定位标签"
                        :disabled="pageType === 'detail' || pageType === 'audit'"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" v-if="showCountInfo">
                    <el-form-item label="积分" prop="integral">
                      <span slot="label" class="inline-block">
                        积分
                        <el-tooltip
                          content="积分是12分制，主要用于违章考核的积分扣除，从而影响作业权限"
                        >
                          <i class="el-icon-question"></i>
                        </el-tooltip>
                      </span>
                      <el-input
                        size="small"
                        v-model.number="formData.integral"
                        :disabled="pageType === 'detail' || pageType === 'audit'"
                        placeholder="请输入积分"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="showCountInfo">
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                    <el-form-item label="入厂时间" prop="entryTime">
                      <el-date-picker
                        size="small"
                        v-model="formData.enterFactoryTime"
                        :disabled="pageType === 'detail' || pageType === 'audit'"
                        class="!w-full"
                        type="date"
                        placeholder="请输入入厂时间"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" v-if="showCountInfo">
                    <el-form-item label="账号" prop="account">
                      <el-input
                        size="small"
                        v-model="formData.account"
                        placeholder="请输入账号"
                        :disabled="pageType === 'detail' || pageType === 'audit'"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-collapse-item>
              <el-collapse-item name="workPerson">
                <template slot="title">
                  <span>特种作业人员</span>
                </template>
                <div>
                  <el-row>
                    <el-col :span="8">
                      <el-form-item
                        label="是否特种作业人员"
                        prop="isSpecialOperationCertificatePersonnel"
                      >
                        <el-select
                          size="small"
                          class="w-full"
                          placeholder="请选择是否特种作业人员"
                          filterable
                          v-model="formData.isSpecialOperationCertificatePersonnel"
                          :disabled="pageType === 'detail' || pageType === 'audit'"
                        >
                          <el-option
                            v-for="item in isSpecialOperationCertificatePersonnelList"
                            :key="item.code"
                            :label="item.displayName"
                            :value="item.code"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8" v-if="formData.isSpecialOperationCertificatePersonnel">
                      <el-form-item label="工种" prop="jobs">
                        <el-select
                          size="small"
                          class="w-full"
                          filterable
                          placeholder="请选择工种"
                          v-model="formData.jobs"
                          :disabled="pageType === 'detail' || pageType === 'audit'"
                        >
                          <el-option
                            v-for="item in jobsList"
                            :key="item.code"
                            :label="item.displayName"
                            :value="Number(item.code)"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <div
                    class="text-right mb-10px"
                    v-if="formData.isSpecialOperationCertificatePersonnel"
                  >
                    <el-button
                      size="mini"
                      type="primary"
                      @click="handleAdd"
                      v-if="pageType !== 'detail' && pageType !== 'audit'"
                      >新增</el-button
                    >
                  </div>
                  <el-row v-if="formData.isSpecialOperationCertificatePersonnel">
                    <el-table
                      :data="formData.contractorPersonnelCertificates"
                      border
                      class="w-full"
                      :height="300"
                      stripe
                    >
                      <el-table-column
                        label="序号"
                        type="index"
                        width="50"
                        align="center"
                      ></el-table-column>
                      <el-table-column
                        label="证书编号"
                        align="center"
                        prop="certificateNumber"
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        label="证书名称"
                        align="center"
                        prop="certificateName"
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        label="证书有效期"
                        align="center"
                        prop="certificateDate"
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        label="证书复审日期"
                        align="center"
                        prop="certificateVerifyDate"
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column label="操作" align="center" width="200">
                        <template slot-scope="scope">
                          <el-button
                            size="mini"
                            v-if="pageType !== 'detail' && pageType !== 'audit'"
                            @click="handleEdit(scope.row, 'update', scope.$index)"
                            >编辑</el-button
                          >
                          <el-button
                            size="mini"
                            @click="handleEdit(scope.row, 'detail', scope.$index)"
                            >查看</el-button
                          >
                          <el-button
                            size="mini"
                            v-if="pageType !== 'detail' && pageType !== 'audit'"
                            @click="handleDel(scope.row, scope.$index)"
                            >删除</el-button
                          >
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-row>
                </div>
              </el-collapse-item>
              <el-collapse-item name="uploadFile">
                <template slot="title">
                  <div class="text-14px">
                    上传资料
                    <span class="text-12px"> (请将相关资料统一汇总到pdf中，并上传)</span>
                  </div>
                </template>
                <!-- <el-form-item class="upload-label" prop="infDocFileId" ref="infDocFileId">
                  <form-upload
                    v-model="formData.infDocFileId"
                    :disabled="pageType === 'detail' || pageType === 'audit'"
                    @change="fileIdChange('infDocFileId')"
                  ></form-upload>
                </el-form-item> -->
                <el-row :gutter="10" class="flex flex-wrap">
                  <el-col :span="8" v-for="(item, index) in formList" :key="index">
                    <p class="font-bold text-sm">
                      <span v-show="!!item.isRequired" class="text-small text-red-500 pr-2px"
                        >*</span
                      >
                      {{ index + 1 }}、{{ item.label }}
                    </p>
                    <div>
                      <el-form-item
                        label="是否有提供："
                        :prop="item.field"
                        :ref="item.field"
                        :rules="[
                          {
                            required: !!item.isRequired,
                            message: `请选择是否提供`,
                            trigger: 'change,blur',
                          },
                        ]"
                      >
                        <el-radio-group
                          v-model="formData[item.field]"
                          @change="(e) => changeText(e, item.field)"
                        >
                          <el-radio
                            :label="true"
                            :disabled="pageType === 'detail' || pageType === 'audit'"
                            >有</el-radio
                          >
                          <el-radio
                            :label="false"
                            :disabled="pageType === 'detail' || pageType === 'audit'"
                            >无</el-radio
                          >
                        </el-radio-group>
                        <!-- FormUpload组件调用fileIdChange方法会报错，暂时先不加，不影响上传文件 -->
                        <form-upload
                          v-model="fileLists[item.field]"
                          :disabled="pageType === 'detail' || pageType === 'audit'"
                          @change="
                            () => {
                              fileChange(item.field)
                            }
                          "
                        ></form-upload>
                      </el-form-item>
                      <!-- <el-form-item
                        v-if="!formData[item.field]"
                        label="说明"
                        :prop="item.textfield"
                        :rules="[
                          {
                            required: true,
                            message: `请输入说明`,
                            trigger: 'change,blur',
                          },
                        ]"
                      >
                        <el-input
                          type="textarea"
                          :rows="3"
                          maxlength="500"
                          show-word-limit
                          placeholder="请输入说明"
                          :disabled="pageType === 'detail' || pageType === 'audit'"
                          v-model="formData[item.textfield]"
                        ></el-input>
                      </el-form-item> -->
                    </div>
                  </el-col>
                </el-row>
              </el-collapse-item>
              <el-collapse-item name="rateInfo" v-if="rateInfo && rateInfo.length > 0">
                <template slot="title">
                  <span>评价信息</span>
                </template>
                <div v-for="(item, index) in rateInfo" :key="index" class="mb-5">
                  <div class="flex justify-between items-center">
                    <div class="flex items-center">
                      <span class="mr-4 text-sm custom-title">{{ item.userName }}</span>
                      <el-rate
                        show-text
                        disabled
                        class="custom-title"
                        v-model="item.evaluationlevel"
                      ></el-rate>
                    </div>
                    <div class="text-gray-400 text-sm">
                      {{ dayjs(item.creationTime).format('YYYY-MM-DD HH:mm:ss') }}
                    </div>
                  </div>
                  <p class="text-sm custom-title" v-if="item.evaluationOpinions">
                    {{ item.evaluationOpinions }}
                  </p>
                </div>
              </el-collapse-item>
              <!-- 退场后，才显示退场单子 -->
              <el-collapse-item name="outInfo" v-if="formData.exitRecordFormFileId">
                <template slot="title">
                  <span>退场单</span>
                </template>
                <form-upload
                  v-if="formData.exitRecordFormFileId"
                  v-model="formData.exitRecordFormFileId"
                  :disabled="true"
                ></form-upload>
              </el-collapse-item>
            </el-collapse>
          </el-form>
        </div>
      </el-col>
    </el-row>
    <div class="w-full flex justify-center items-center mt-5 mb-5">
      <el-button
        type="primary"
        size="small"
        @click="handleSave"
        :loading="saveLoading"
        v-if="pageType !== 'detail' && pageType !== 'audit'"
        >保存</el-button
      >
      <el-button type="primary" size="small" @click="handleAudit" v-if="pageType === 'audit'"
        >审批</el-button
      >
      <el-button @click="$emit('back')" v-if="pageType !== 'detail'" size="small">取消</el-button>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      title="人员证书"
      :visible.sync="cardDialog"
      class="small-dialog"
      v-dialogDrag
    >
      <el-form
        ref="formCard"
        label-width="130px"
        :rules="cardRules"
        :model="currentDetail"
        v-if="cardDialog"
      >
        <el-form-item label="证书编号" prop="certificateNumber">
          <el-input
            size="small"
            v-model="currentDetail.certificateNumber"
            placeholder="请输入证书编号"
            :disabled="cardAdd === 'detail'"
          ></el-input>
        </el-form-item>
        <el-form-item label="证书名称" prop="certificateName">
          <el-input
            size="small"
            v-model="currentDetail.certificateName"
            placeholder="请输入证书名称"
            :disabled="cardAdd === 'detail'"
          ></el-input>
        </el-form-item>
        <el-form-item label="证书有效期" prop="certificateDate">
          <el-date-picker
            size="small"
            v-model="currentDetail.certificateDate"
            :disabled="cardAdd === 'detail'"
            class="!w-440px"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="证书有效期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="证书复审日期">
          <el-date-picker
            size="small"
            v-model="currentDetail.certificateVerifyDate"
            :disabled="cardAdd === 'detail'"
            class="!w-440px"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="证书复审日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="证书附件" prop="certificateFileId" ref="certificateFileId">
          <form-upload
            @change="fileIdChange('certificateFileId')"
            v-model="currentDetail.certificateFileId"
            :disabled="cardAdd === 'detail'"
          ></form-upload>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="flex justify-center"
        v-if="!(pageType === 'detail' || cardAdd === 'detail')"
      >
        <el-button
          size="small"
          type="primary"
          @click="handleSaveCard"
          :disabled="pageType === 'detail' || cardAdd === 'detail'"
          >确定</el-button
        >
        <el-button size="small" @click="cardDialog = false">取消</el-button>
      </div>
    </el-dialog>
    <FaceAvatarStandard :visible.sync="dialogExampleShow" />

    <!-- 审批弹窗 -->
    <el-dialog
      v-if="visible"
      :close-on-click-modal="false"
      title="审批"
      :visible.sync="visible"
      class="small-dialog"
      v-dialogDrag
      append-to-body
    >
      <el-form ref="checkResultForm" label-width="150px" :model="checkResultForm">
        <el-form-item
          label="审批结果"
          prop="isPass"
          :rules="[{ required: true, message: '请选择审批结果', trigger: 'blur' }]"
        >
          <el-radio-group v-model="checkResultForm.isPass">
            <el-radio :label="true">审批通过</el-radio>
            <el-radio :label="false">不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="审批意见"
          prop="approve"
          :rules="[{ required: true, message: '请输入审批意见', trigger: 'blur' }]"
          v-if="!checkResultForm.isPass"
        >
          <el-input
            v-model="checkResultForm.approve"
            type="textarea"
            :rows="4"
            maxlength="500"
            show-word-limit
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex justify-center">
        <el-button size="small" type="primary" @click="handleSaveResult" :loading="cardLoading"
          >保存</el-button
        >
        <el-button size="small" @click="cancelResult">取消</el-button>
      </div>
    </el-dialog>

    <!-- 选择人员弹窗start -->
    <SelectDeptUser
      v-if="showUserDialog"
      :visible.sync="showUserDialog"
      :flowName="flowName"
      :nodeName="nodeName"
      @selectSuccess="selectSuccess"
    ></SelectDeptUser>
    <!-- 选择人员弹窗end -->
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { forIn, find, isNil } from 'lodash'
import {
  ContractorApi,
  ContractorPersonnelApi,
  ContractorProjectApi,
  ContractorAccountRelationApi,
  ValuativeInformationApi,
} from '@wiz-api/contractor-management'
import { AbpApplicationConfigurationApi } from '@wiz-api/abp-application'
import { TeamApi, SpecialtyApi } from '@wiz-api/team-management'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import { FileApi } from '@wiz-api/file-management'
import ImgUpload from '@/components/safety/ImgUpload/ImgUpload'
import FormUpload from '@/components/safety/FileUpload/FormUpload'
import utils from '@/components/safety/enumField/utils'
import SelectDeptUser from '@/modules/contractor-management-sm/components/SelectDeptUser'
import DiyService from '@/modules/contractor-management-sm/services/DiyService'

const contractorApi = new ContractorApi()
const fileApi = new FileApi()
const valuativeInformationApi = new ValuativeInformationApi()
const contractorProjectApi = new ContractorProjectApi()
const contractorPersonnelApi = new ContractorPersonnelApi()
const contractorAccountRelationApi = new ContractorAccountRelationApi()
const dataCategoryApi = new DataCategoryApi()
const abpApplicationConfigurationApi = new AbpApplicationConfigurationApi()
const specialtyApi = new SpecialtyApi()
const teamApi = new TeamApi()
const FaceAvatarStandard = () => {
  return import('./FaceAvatarStandard')
}
export default {
  name: 'PersonEnterContent',
  components: {
    ImgUpload,
    FormUpload,
    FaceAvatarStandard,
    SelectDeptUser,
  },
  props: {
    // 任务流程id
    taskId: {
      type: String,
      default: '',
    },
    // 页面类型
    pageType: {
      type: String,
      default: 'create',
    },
    FormData: {
      type: Object,
      default: () => {},
    },
    // 资质指引模板
    formList: {
      type: Array,
      default: () => {
        return []
      },
    },
    // 是否账号积分信息
    showCountInfo: {
      type: Boolean,
      default: false,
    },
    // 当前页面 只有承包商人员档案页面才显示评价信息
    currentPage: {
      type: String,
      default: '',
    },
    // 是否为承包商负责人 0 承包商负责人 1 承包商人员
    accountType: {
      type: Number,
      default: null,
    },
    flowTaskId: {
      type: [String, Number],
      default: null,
    },
    isSelectUser: {
      type: Boolean,
      default: false,
    }, // 是否有人员选择功能
    flowName: {
      type: String,
      default: '',
    }, // 流程名称
    nodeName: {
      type: String,
      default: '',
    }, // 需要获取人员的节点名称
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('手机号不能为空'))
        return
      }
      const reg = /^1[3-9]{1}[0-9]{9}$/
      if (!reg.test(value)) {
        callback(new Error('请填写正确的手机号'))
        return
      }
      callback()
    }

    // 身份证验证
    const validateCard = (rule, value, callback) => {
      const reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      if (!value) {
        callback(new Error('请输入身份证号码'))
      } else if (reg.test(value)) {
        callback()
      } else {
        callback(new Error('请输入正确的身份证号码'))
      }
    }

    // 姓名校验
    const validateName = (rule, value, callback) => {
      // 中文
      const reg = /^[a-zA-Z]+$|^[\u4E00-\u9FA5]+$/
      if (!value) {
        callback(new Error('请输入姓名'))
      } else if (!reg.test(value)) {
        callback(new Error('姓名只能全中文或者全英文'))
      } else {
        callback()
      }
    }
    return {
      teamList: [],
      showUserDialog: false, // 是否显示选择人员弹窗
      specialtyList: [],
      visible: false,
      cardLoading: false,
      // 审批表单
      checkResultForm: {
        isPass: true,
        approve: '',
      },
      saveLoading: false,
      contractorId: '',
      profileTemplateId: '',
      dialogExampleShow: false,
      // 关联项目
      projectList: [],
      contractorNames: [],
      personnelCategoryList: [],
      sexList: [],
      dutieJobList: [],
      educationList: [],
      // 当前数据索引
      index: null,
      // create新增 update编辑 detail详情
      cardAdd: 'create',
      fileCardList: [],
      currentDetail: {
        certificateNumber: '',
        certificateName: '',
        certificateDate: '',
        certificateFileId: '',
        certificateFileName: '',
      },
      cardRules: {
        certificateNumber: [
          { required: true, message: '请输入证书编号', trigger: ['blur', 'change'] },
        ],
        certificateName: [
          { required: true, message: '请输入证书名称', trigger: ['blur', 'change'] },
        ],
        certificateDate: [
          { required: true, message: '请选择证书日期', trigger: ['blur', 'change'] },
        ],
        certificateFileId: [
          { required: true, message: '请上传证书附件', trigger: ['blur', 'change'] },
        ],
      },
      cardDialog: false,
      rateInfo: [],
      activeNames: ['baseInfo', 'workPerson', 'uploadFile', 'rateInfo', 'outInfo'],
      formData: {
        orgName: '',
        orgShortName: '',
        orgLeader: '',
        phoneNumber: '',
        idCard: '',
        email: '',
        exitRecordFormFileId: undefined,
        infDocFileId: {},
        teamId: '',
      },
      fileLists: {},
      isSpecialOperationCertificatePersonnelList: [
        {
          displayName: '是',
          code: true,
        },
        {
          displayName: '否',
          code: false,
        },
      ],
      jobsList: [],
      rules: {
        // 照片改为非必填
        // headshotFileId: [
        //   { required: true, message: '请上传人脸头像', trigger: ['blur', 'change'] },
        // ],
        contractorId: [{ required: true, message: '请选择所属单位', trigger: ['blur', 'change'] }],
        personnelCategory: [
          { required: true, message: '请选择人员分类', trigger: ['blur', 'change'] },
        ],
        phoneNumber: [{ required: true, validator: validatePhone, trigger: ['blur', 'change'] }],
        name: [{ required: true, validator: validateName, trigger: ['blur', 'change'] }],
        sex: [{ required: true, message: '请选择性别', trigger: ['blur', 'change'] }],
        isTemp: [{ required: true, message: '请选择是否为临时工', trigger: ['blur', 'change'] }],
        age: [
          { required: true, message: '请输入年龄' },
          { type: 'number', message: '年龄必须为数值' },
        ],
        idCard: [{ required: true, validator: validateCard, trigger: ['blur'] }],
        // infDocFileId: [{ required: true, message: '请上传审核资料', trigger: ['blur', 'change'] }],
        idCardFrontFileId: [
          { required: true, message: '请上传身份证正面', trigger: ['blur', 'change'] },
        ],
        idCardReverseFileId: [
          { required: true, message: '请上传身份证反面', trigger: ['blur', 'change'] },
        ],
        // jobs: [{ required: true, message: '请选择工种', trigger: ['blur', 'change'] }],
        insuranceType: [{ required: true, message: '请选择保险类型', trigger: ['blur', 'change'] }],
        insuranceValidityPeriod: [
          { required: true, message: '请选择保险有效期', trigger: ['blur', 'change'] },
        ],
        isPhysicalExaminationQualified: [
          { required: true, message: '请选择体检是否合格', trigger: ['blur', 'change'] },
        ],
        laborContractTerminationDate: [
          { required: true, message: '请选择劳动合同终止日期', trigger: ['blur', 'change'] },
        ],
        // homeAddress: [{ required: true, message: '请输入家庭住址', trigger: ['blur', 'change'] }],
      },
      flowHistoryList: [], // 已审批流程数据
      useSelectUser: false, // 是否启用人员选择功能
      flowStepsList: [], // 流程步骤
    }
  },
  watch: {
    FormData: {
      handler(newVal, oldVal) {
        console.log(11111, newVal)
        this.formData = newVal
      },
      immediate: true,
    },
  },
  async created() {
    this.useSelectUser = this.isSelectUser
    if (this.$route.query?.isSelectUser === 'true') {
      this.useSelectUser = true
    }
    await this.getFlowList()
    await this.getFlowStepsList()
    this.getConfig()
    this.getGuideList()
    this.getSpecialtyList()
    this.getTeamList()
    // 判断当前用户是否为承包商
    this.getContractorInfo()
    if (this.pageType === 'detail' && this.currentPage === 'PersonFiles') {
      this.getEvaluateInfo()
    }
    this.formList.forEach((item) => {
      if (this.pageType === 'create') {
        this.formData[item.field] = false
      } else {
        this.formData[item.field] = !isNil(this.formData[item.field])
          ? this.formData[item.field]
          : false
      }
      this.fileLists[item.field] = item.infDocFileId
    })
    this.fileLists = { ...this.fileLists }
  },
  methods: {
    /**
     * @description 文件上传/删除回调方法
     * @param {String} field 文件上传/删除对应的字段
     */
    fileChange(field) {
      this.formData = { ...this.formData }
      this.formData[field] = !!this.fileLists[field]
    },

    async getTeamList() {
      const data = { IsEnabledPermissions: true }
      if (this.pageType === 'detail' || this.pageType === 'audit' || this.accountType === 0) {
        data.IsEnabledPermissions = false
      }
      const [err, res] = await teamApi.getTeamList({ body: data })
      console.log(res)
      if (!err) {
        this.teamList = res
      }
    },

    /**
     * @description 获取已审批流程数据
     */
    async getFlowList() {
      const [err, res] = await DiyService.getFlowHistoryList({
        FlowId: this.flowTaskId,
      })
      if (!err && res?.Code === 1 && res?.Data) {
        this.flowHistoryList = res.Data
      }
    },

    /**
     * @description 获取流程步骤
     */
    async getFlowStepsList() {
      if (!this.flowHistoryList?.length) return
      const [err, res] = await DiyService.getTableData({
        TableName: 'WF_Node',
        _SearchEqual: { FlowDesignId: this.flowHistoryList[0].FlowDesignId },
      })
      if (!err && res?.Code === 1 && res?.Data) {
        this.flowStepsList = res.Data
      }
    },

    /**
     * @description 选择人员完成
     * @param {Array} userIds 人员id
     */
    async selectSuccess(userIds) {
      this.cardLoading = true
      const [err, res] = await contractorPersonnelApi.entryApprove({
        body: {
          id: this.formData.id,
          taskId: this.taskId,
          ...this.checkResultForm,
          receiverIds: userIds,
        },
      })
      // const [err] = await contractorPersonnelApi.entrySubmit({
      //   personId: this.operateRow.id,
      //   receiverIds: userIds,
      // })
      this.cardLoading = false
      if (!err) {
        this.$message({
          showClose: true,
          message: '审批成功',
          type: 'success',
        })
        this.visible = false
        this.$emit('save')
      }
    },

    async getSpecialtyList() {
      const [err, res] = await specialtyApi.getSpecialtyDropDown()
      if (!err) {
        this.specialtyList = res
        this.specialtyList.unshift({ id: '00000000-0000-0000-0000-000000000000', name: '无专业' })
      }
    },
    handleAudit() {
      this.checkResultForm = this.$options.data().checkResultForm
      this.visible = true
    },
    // 取消审批
    cancelResult() {
      this.visible = false
    },
    // 审批
    handleSaveResult() {
      this.$refs.checkResultForm.validate(async (valid) => {
        if (valid) {
          const currentFlowNode = find(this.flowStepsList, (step) => {
            return this.flowHistoryList[0]?.ToNodeName === step.NodeName
          })
          if (
            this.useSelectUser &&
            currentFlowNode &&
            currentFlowNode.NodeType !== 'End' &&
            this.checkResultForm.isPass
          ) {
            this.showUserDialog = true
            return
          }
          this.cardLoading = true
          const [err, res] = await contractorPersonnelApi.entryApprove({
            body: {
              id: this.formData.id,
              taskId: this.taskId,
              ...this.checkResultForm,
            },
          })
          if (!err) {
            this.$message({
              showClose: true,
              message: '审批成功',
              type: 'success',
            })
            this.visible = false
            this.$emit('save')
          }
          this.cardLoading = false
        }
      })
    },
    // 切换有无
    changeText(val, field) {
      if (val) {
        this.formData[`text${field}`] = ''
      }
    },
    // 查询用户评价信息
    async getEvaluateInfo() {
      const [error, res] = await valuativeInformationApi.valuativeInformationList({
        relatedId: this.formData.id,
      })
      if (!error) {
        this.rateInfo = res || []
      }
    },
    fileIdChange(key) {
      this.$refs[key].$emit('el.form.change')
    },
    // 切换所属单位，获取关联项目列表
    changeContractorId(value) {
      if (value) {
        const contractor = find(this.contractorNames, { id: value })
        this.formData.ownerdSpecialtyId = contractor?.ownerdSpecialtyId
        // formData.ownerdSpecialtyId
        // 获取项目清单列表
        this.getSafetyProjectList()
      } else {
        this.formData.ownerdSpecialtyId = ''
        this.projectList = []
      }
      // this.formData.projectId = ''
      this.formData.projectName = ''
    },
    // 判断当前用户是否为承包商,展示对应的所属单位以及关联项目
    async getContractorInfo() {
      const [err, res] = await contractorAccountRelationApi.getContractorAccountRelationByUserDto()
      if (!err) {
        this.contractorId = res.contractorId
        this.profileTemplateId = res.profileTemplateId
        // 获取承包商人员列表
        this.getContractorNames()
      }
    },
    // 拿到图片内容
    async getImageContent(content) {
      // 0 承包商账号负责人不做身份证识别校验
      if (this.accountType === 0) return
      const [err, res] = await contractorPersonnelApi.getContractorPersonnelIDCardFileContent({
        files: [content],
      })
      if (!err) {
        const { age, idCard, name, national, sex } = res
        this.formData.age = age || this.formData.age
        this.formData.idCard = idCard || this.formData.idCard
        this.formData.name = name || this.formData.name
        this.formData.national = national || this.formData.national
        // 性别字典对应
        if (sex) {
          if (sex === '男') {
            this.formData.sex = 0
          } else {
            this.formData.sex = 1
          }
        }
      }
    },
    // TODO:暂时去掉身份校验
    // 获取人员信息,判断当前人员是否在黑名单
    // async getPersonInfo() {
    //   // 判断人员是否在黑名单
    //   const [err, res] = await contractorPersonnelApi.isContractorPersonnelblacklist({
    //     idCard: this.formData.idCard,
    //   })
    //   if (!err) {
    //     // 是黑名单
    //     if (res) {
    //       // 清除身份证字段
    //       this.formData.idCard = undefined
    //       this.$confirm('该人员已存在黑名单，不允许添加！', '提示', {
    //         confirmButtonText: '确定',
    //         cancelButtonText: '取消',
    //         type: 'warning',
    //       })
    //         .then(async () => {})
    //         .catch(() => {})
    //     }
    //   }
    // },
    // 头像要求示范
    damendExample() {
      this.dialogExampleShow = true
    },
    // 获取数据字典
    async getConfig() {
      let ids = []
      const [configError, abpConfigList] = await abpApplicationConfigurationApi.get()
      if (!configError) {
        const [statusError, statusRes] = await dataCategoryApi.getListByCodes({
          codes: [
            abpConfigList.setting.values['ContractorManagement.DataCategory.DutieJob'],
            abpConfigList.setting.values['ContractorManagement.DataCategory.Education'],
            abpConfigList.setting.values['ContractorManagement.DataCategory.Sex'],
            abpConfigList.setting.values['ContractorManagement.DataCategory.Team'],
            abpConfigList.setting.values['ContractorManagement.DataCategory.PersonnelCategory'],
            abpConfigList.setting.values['ContractorManagement.DataCategory.Jobs'],
            abpConfigList.setting.values[
              'ContractorManagement.DataCategory.IsSpecialOperationCertificatePersonnel'
            ],
          ],
          includeDetails: true,
        })
        if (!statusError) {
          ids = statusRes.map((item) => {
            return item.id
          })
          this.getItemsByIds(ids)
        }
      }
    },
    // 获取数据字典列表
    async getItemsByIds(ids) {
      const [err, res] = await dataCategoryApi.getListByIds({
        ids,
        includeDetails: true,
      })
      if (!err) {
        // 人员分类
        this.personnelCategoryList = res.filter((item) => {
          return item.code === 'PersonnelCategory'
        })[0].dataItems

        // 性别
        this.sexList = res.filter((item) => {
          return item.code === 'Sex'
        })[0].dataItems

        // 文化程度
        this.educationList = res.filter((item) => {
          return item.code === 'Education'
        })[0].dataItems

        // 职务/工种
        this.dutieJobList = res.filter((item) => {
          return item.code === 'DutieJob'
        })[0].dataItems

        // 工种
        this.jobsList = res.filter((item) => {
          return item.code === 'Jobs'
        })[0].dataItems
      }
    },
    /**
     * 删除已上传的图片
     * @param {*} index 索引
     * @param {*} type 图片类型
     */
    deleteImg(index, type) {
      this.formData[type] = ''
    },
    /**
     * 删除已上传的证书图片
     * @param {*} index 索引
     * @param {*} type 图片类型
     */
    deleteCardImg(index, type) {
      this.currentDetail[type] = ''
    },
    // 保存证书
    handleSaveCard() {
      this.$refs.formCard.validate((valid) => {
        if (valid) {
          if (this.cardAdd === 'create') {
            this.currentDetail = this.formData.contractorPersonnelCertificates.push(
              this.currentDetail
            )
          } else {
            forIn(this.currentDetail, (value, key) => {
              this.$set(this.formData.contractorPersonnelCertificates[this.index], key, value)
            })
          }
          this.cardDialog = false
        }
      })
    },
    // 获取承包商名称列表
    async getContractorNames() {
      const data = { isCurrentUserlimit: true }
      if (this.pageType === 'detail' || this.pageType === 'audit' || this.accountType === 0) {
        data.isCurrentUserlimit = false
      }
      const [err, res] = await contractorApi.contractorNamesDto(data)
      if (!err) {
        // 新增默认选中单位
        if (this.pageType === 'create') {
          this.contractorNames = res.filter((item) => {
            return item.status === 1 && item.isBlock === false
          })
          if (this.contractorId && this.contractorNames && this.contractorNames.length > 0) {
            this.formData.contractorId = this.contractorNames[0].id
            this.formData.ownerdSpecialtyId = this.contractorNames[0].ownerdSpecialtyId
          }
        } else {
          this.contractorNames = res
        }
        // 获取项目清单列表
        this.getSafetyProjectList()
      }
    },
    // 人员入厂指引列表
    async getGuideList() {
      // 数组转对象 obj 资料审核对象，动态生成对象，便于展示
      const obj = this.arrToObj(this.formList)
      this.formData = {
        ...this.formData,
        ...obj,
      }
    },
    /**
     * 数组转换成form表单对象
     * @param {*} arr 目标数组
     */
    arrToObj(arr) {
      const obj = {}
      arr.forEach((ele) => {
        // 对应字段内容填充 有无提供 说明
        obj[ele.field] =
          ele.isProvided !== null && ele.isProvided !== '' && ele.isProvided !== undefined
            ? !!ele.isProvided
            : true
        obj[ele.textfield] = ele.description ? ele.description : undefined
      })
      return obj
    },
    // 获取项目清单列表
    async getSafetyProjectList() {
      const data = {
        // 默认传当前承包商id， 承包商id不存在，传用户选择的所属单位（承包商）id
        contractorId: this.contractorId || this.formData.contractorId,
        maxResultCount: 1000, // 每页多少条
        skipCount: 0, // 跳过多少条
      }
      const [error, result] = await contractorProjectApi.relatedProjectPageList(data)
      if (!error) {
        this.projectList = result.items || []
      }
    },
    // 新增
    handleAdd() {
      this.cardAdd = 'create'
      this.currentDetail = {
        certificateNumber: '',
        certificateName: '',
        certificateDate: '',
        certificateFileId: '',
        certificateFileName: '',
      }
      this.fileCardList = []
      this.cardDialog = true
      this.$nextTick(() => {
        this.$refs.formCard.resetFields()
      })
    },
    // 保存
    handleSave() {
      // 是否特种人员选择否，删除工种信息以及人员证书信息
      if (!this.formData.isSpecialOperationCertificatePersonnel) {
        this.formData.jobs = null
        this.formData.contractorPersonnelCertificates = []
      }

      // 格式化时间
      if (
        this.formData.contractorPersonnelCertificates &&
        this.formData.contractorPersonnelCertificates.length > 0
      ) {
        this.formData.contractorPersonnelCertificates.forEach((item) => {
          item.certificateDate = dayjs(item.certificateDate).format('YYYY-MM-DD HH:mm:ss')
          if (item.certificateVerifyDate) {
            item.certificateVerifyDate = dayjs(item.certificateVerifyDate).format(
              'YYYY-MM-DD HH:mm:ss'
            )
          }
        })
      }
      // 重组数据，是否提供入厂资料
      const relationList = []
      this.formList.forEach((item, index) => {
        relationList.push({
          contractorPersonnelId: this.formData.id ? this.formData.id : undefined,
          id: item.id ? item.id : undefined,
          configurationId: item.configurationId,
          isProvided: this.formData[`${item.field}`],
          description: this.formData[`text${item.field}`],
          infDocFileId: this.fileLists[item.field] || null,
        })
      })

      this.$set(this.formData, 'contractorPersonnelConfigurations', relationList)
      this.$refs.formBase.validate(async (valid) => {
        if (valid) {
          const unUploadItemList = []
          this.formList.forEach((item) => {
            if (this.formData[item.field] && !this.fileLists[item.field]) {
              // 检验上传资料必上传项是否有未上传的
              unUploadItemList.push(item.label)
            }
          })
          if (unUploadItemList.length) {
            this.$message.warning(`${unUploadItemList.join('、')}项文件未上传`)
            return
          }
          this.saveLoading = true
          if (this.formData.joinedWorkTime) {
            this.formData.joinedWorkTime = dayjs(this.formData.joinedWorkTime).format(
              'YYYY-MM-DD HH:mm:ss'
            )
          }
          if (this.formData.laborContractTerminationDate) {
            this.formData.laborContractTerminationDate = dayjs(
              this.formData.laborContractTerminationDate
            ).format('YYYY-MM-DD HH:mm:ss')
          }
          if (this.formData.insuranceValidityPeriod) {
            this.formData.insuranceValidityPeriod = dayjs(
              this.formData.insuranceValidityPeriod
            ).format('YYYY-MM-DD HH:mm:ss')
          }
          this.formData = utils.deleteFormField(this.formData)
          if (this.pageType === 'create' || this.pageType === 'resetFactory') {
            if (this.pageType === 'resetFactory') {
              // 重置条件
              delete this.formData.id
              this.formData.status = 0
              this.formData.workflowStatus = 0
              this.formData.exitWorkflowStatus = 0
            }
            const [err, res] = await contractorPersonnelApi.contractorPersonnelCreateInputDto({
              body: this.formData,
            })
            if (!err) {
              if (this.pageType === 'resetFactory') {
                this.$message({
                  showClose: true,
                  message: '返厂成功',
                  type: 'success',
                })
                this.$emit('save')
              } else {
                this.$message({
                  showClose: true,
                  message: '新增成功',
                  type: 'success',
                })
                this.$emit('save')
              }
            }
            this.saveLoading = false
          } else {
            const [err, res] = await contractorPersonnelApi.contractorPersonnelUpdateInputDto({
              body: this.formData,
            })
            if (!err) {
              this.$message({
                showClose: true,
                message: '编辑成功',
                type: 'success',
              })
              this.$emit('save')
            }
            this.saveLoading = false
          }
        }
      })
    },
    // 删除
    handleDel(row, index) {
      this.$confirm('是否删除该证书？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          this.formData.contractorPersonnelCertificates.splice(index, 1)
        })
        .catch(() => {})
      this.$nextTick(() => {})
    },
    // 1编辑 2查看
    handleEdit(row, type, index) {
      this.index = index
      this.cardDialog = true
      this.cardAdd = type
      this.currentDetail = JSON.parse(JSON.stringify(row))
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-divider__text {
  font-weight: bold;
  font-size: 16px;
}

::v-deep .el-card__body {
  height: 100%;
  padding-bottom: 0 !important;
}

::v-deep .withbutton-height {
  height: calc(100% - 50px);
}

::v-deep .nobutton-height {
  height: calc(100% - 10px);
}

.custom-title {
  color: var(--textColor);
}

::v-deep .upload-label {
  .el-form-item {
    margin-left: 180px !important;
  }
  .el-form-item__label {
    float: none !important;
  }

  .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>
